/** Site copy and links — single place to update as the site grows. */
export const site = {
  title: 'Post Masquerade',
  tagline: "Music. Writing. Whatever's underneath.",
  email: 'postmasquerade@gmail.com',
  audio: {
    trackName: 'Black Lake',
    hint: 'Tap to listen',
  },
  links: {
    spotify: 'https://open.spotify.com/artist/6VtwMOLw5eJMvv9ixXu0bp',
    appleMusic: 'https://music.apple.com/us/artist/post-masquerade/1716631370',
    amazonMusic: 'https://music.amazon.com/artists/B0CNSDMLVG/post-masquerade',
    deezer: 'https://www.deezer.com/us/artist/244326292',
    soundcloud: 'https://soundcloud.com/post-masquerade',
    youtube: 'https://www.youtube.com/@post_masquerade',
    substack: 'https://substack.com/@postmasquerade',
    instagram: 'https://www.instagram.com/post_masquerade',
    etsy: null,
  },
  listenPlatforms: [
    { label: 'Spotify', key: 'spotify' },
    { label: 'Apple Music', key: 'appleMusic' },
    { label: 'Amazon Music', key: 'amazonMusic' },
    { label: 'Deezer', key: 'deezer' },
    { label: 'SoundCloud', key: 'soundcloud' },
    { label: 'YouTube', key: 'youtube' },
  ],
  listen: {
    heading: 'Listen',
    intro: 'Songs from the other side of the mask — wherever you stream.',
  },
  footerGroups: [
    {
      label: 'Music',
      links: [
        { label: 'Spotify', key: 'spotify' },
        { label: 'Apple Music', key: 'appleMusic' },
        { label: 'Amazon Music', key: 'amazonMusic' },
        { label: 'Deezer', key: 'deezer' },
        { label: 'SoundCloud', key: 'soundcloud' },
        { label: 'YouTube', key: 'youtube' },
      ],
    },
    {
      label: 'Writing',
      links: [{ label: 'Substack', key: 'substack' }],
    },
    {
      label: 'Connect',
      links: [{ label: 'Instagram', key: 'instagram' }],
    },
  ],
  cards: [
    {
      id: 'listen',
      label: 'Listen',
      desc: 'Songs from the other side of the mask.',
      href: '#listen',
      external: false,
    },
    {
      id: 'read',
      label: 'Read',
      desc: "Essays, fragments, and things that wouldn't fit in a song.",
      href: 'https://substack.com/@postmasquerade',
      external: true,
    },
    {
      id: 'story',
      label: 'The Story',
      desc: 'Where the forest ends and the music begins.',
      href: '#story',
      external: false,
    },
    {
      id: 'stones',
      label: 'Stones',
      desc: 'Stone cage necklaces and things you can hold.',
      opensDialog: 'stones',
    },
  ],
  story: {
    heading: 'The Story',
    paragraphs: [
      "I grew up in a forest in the Pacific Northwest where I knew where every huckleberry bush was. The trees didn't ask questions. They just stood there, holding space for whatever you couldn't say out loud.",
      "I learned early that some things are easier to feel than to explain — the weight of wet moss, the way light breaks through cedar, the silence between footsteps on a trail no one else walked. Music became another kind of forest. A place where the unsaid could live without needing a name.",
      "Post Masquerade is what came after the mask came off — or at least, after I stopped pretending it wasn't there. Late-diagnosed autistic. Musician. Writer. Still learning what it means to be seen.",
      'This is the work from the other side: ambient textures and honest words, warm light in all that darkness. Not a performance. A presence.',
    ],
  },
  stones: {
    heading: 'Stones',
    text: 'Stone cage necklaces — talismans you can wear. Each one holds something. The shop is coming soon.',
    etsy: {
      label: 'Etsy',
      desc: 'Stone cage necklaces',
      comingSoon: true,
      comingSoonMessage:
        "Coming soon! (I think. I mean...we'll see if that side quest becomes hyperfocusy enough but I would really like to make them available because I like to wear them and my family likes to wear them and they're actually pretty cool...but, we'll see.)",
      dismissLabel: "Okay, we'll see",
    },
  },
  footer: {
    bio: 'Post Masquerade is Brian — musician, writer, late-diagnosed autistic. Making music and meaning from the other side of the mask.',
  },
};
